import React from 'react';

const SelectBox = ({ selectLists = [], handleSelectBox, handleSelectBoxName }: any) => {
  const handleChangeSelect = (e: any) => {
    const selectedId = e.target.value;
    const selected = (selectLists || []).find(
      (item: any) =>
        String(item?.fourthSeq?.empId || item?.empId || item?.EMP_ID || item?.EMP_EMAIL) ===
        String(selectedId)
    );
    handleSelectBox(selectedId);
    handleSelectBoxName(selected ? selected.EMP_NM || selected.empNm || selected.Name || '' : '');
  };

  return (
    <>
      <select onChange={handleChangeSelect}>
        {(selectLists || []).map((options: any, idx: number) => {
          const value =
            options?.fourthSeq?.empId ||
            options?.empId ||
            options?.EMP_ID ||
            options?.EMP_EMAIL ||
            idx;
          const label = options?.EMP_NM || options?.empNm || options?.Name || '';
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </select>
    </>
  );
};

export default SelectBox;
